const { INTERNAL_SERVER_ERROR } = require('http-status-codes')

const TRANSLATION_KEY = null
const DEFAULT_MESSAGE = ''

class ErrorBase extends Error {
  // message field will be used to pass error message to developer in english
  // translationKey is the key for translating error message for end user in desired language on frontend
  constructor (message, translationKey, code) {
    super(message || DEFAULT_MESSAGE)
    this.translationKey = translationKey || TRANSLATION_KEY
    this.code = code || INTERNAL_SERVER_ERROR
  }
}

Object.defineProperty(ErrorBase, 'name', {
  writable: true,
  value: 'Error'
})

module.exports = {
  ErrorBase
}
